export const isTextLinkyfied = (text: string): boolean => {
  const urlRegex = /https?:\/\/[^\s]+|www\.[^\s]+/gi

  return urlRegex.test(text)
}
